import { render, staticRenderFns } from "./regionListCard.vue?vue&type=template&id=dcec53f4&scoped=true"
import script from "./regionListCard.vue?vue&type=script&lang=js"
export * from "./regionListCard.vue?vue&type=script&lang=js"
import style0 from "./regionListCard.vue?vue&type=style&index=0&id=dcec53f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcec53f4",
  null
  
)

export default component.exports